// extracted by mini-css-extract-plugin
export default {"main":"headingWithUnderline_main__w8r9A"};